import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import { App } from "@/App";
import { registerServiceWorker } from "@/registerSw";

import "@/styles/tokens.css";

const root = document.querySelector("#root");
if (!root) throw new Error("index.html is missing its #root element");

registerServiceWorker();

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
